module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-137.9b3c2881.svg";